export default __webpack_public_path__ + "static/media/P305 zu P316.a6740d44.mp3";